import { useEffect, useRef } from "react";
import gsap from "gsap";
import "./LoadingScreen.css";
import logodark from '../images/logodark.webp';

const LoadingScreen = ({ onComplete }) => {
  const containerRef = useRef(null);
  const counterRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    const counter = counterRef.current;

    const tl = gsap.timeline({
      onComplete: () => {
        gsap.to(container, {
          clipPath: "inset(0% 0% 100% 0%)",
          duration: 1,
          ease: "power2.inOut",
          onComplete: () => {
            if (onComplete) onComplete();
          },
        });
      },
    });

    tl.to(
      { value: 0 },
      {
        value: 100,
        duration: 2,
        ease: "power2.inOut",
        onUpdate: function () {
          if (counter) {
            const value = Math.round(this.targets()[0].value);
            counter.textContent = String(value).padStart(3, '0');
          }
        },
      }
    );

    tl.to({}, { duration: 0.3 });

  }, [onComplete]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="loading-screen" ref={containerRef}>
      <div className="loading-top">
        <img className="loading-logo" src={logodark} alt="logo" />
      </div>
      <div className="loading-bottom">
        <p className="loading-counter" ref={counterRef}>000</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
